import { Button, ToggleSwitch } from "flowbite-react";
import { HiPlus } from "react-icons/hi";
import { useTranslation } from "react-i18next";
import { DateRangeRow } from "./DateRangeRow";

export const SeasonalitySection = ({
  dateRanges,
  excludeWeekends,
  onUpdate,
  onAdd,
  onRemove,
  onToggleWeekends,
  disabled,
}) => {
  const { t } = useTranslation();

  return (
    <div>
      <h2 className="text-xl font-semibold text-gray-900">
        {t("pages.settings.actionsSettings.seasonality.title")}
      </h2>
      <p className="mb-4 mt-1 text-sm text-gray-500">
        {t("pages.settings.actionsSettings.seasonality.description")}
      </p>

      <div className="mb-6">
        <ToggleSwitch
          checked={excludeWeekends}
          onChange={onToggleWeekends}
          disabled={disabled}
          label={t(
            "pages.settings.actionsSettings.seasonality.excludeWeekends",
          )}
        />
      </div>

      <div className="space-y-3">
        {dateRanges.map((dateRange, index) => (
          <DateRangeRow
            key={dateRange.id || index}
            dateRange={dateRange}
            index={index}
            onUpdate={onUpdate}
            onRemove={onRemove}
            disabled={disabled}
          />
        ))}

        {dateRanges.length === 0 && (
          <p className="text-sm text-gray-500">
            {t("pages.settings.actionsSettings.seasonality.noRanges")}
          </p>
        )}

        <Button color="light" size="sm" onClick={onAdd} disabled={disabled}>
          <HiPlus className="mr-2 h-4 w-4" />
          {t("pages.settings.actionsSettings.seasonality.addRange")}
        </Button>
      </div>
    </div>
  );
};
